import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["tagName", "component", "children", "refCallback", "innerRef", "className"];
/* eslint-disable react/prop-types */
import * as React from 'react';
import clsx from 'clsx';
import { useText } from './useText';
function Text(_ref) {
  var _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'span' : _ref$tagName,
    component = _ref.component,
    children = _ref.children,
    refCallback = _ref.refCallback,
    innerRef = _ref.innerRef,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var _useText = useText(extraProps),
    _useText2 = _slicedToArray(_useText, 2),
    textClasses = _useText2[0],
    textExtra = _useText2[1];
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.cloneElement(component, _objectSpread({
      ref: refCallback,
      className: clsx(textClasses, component.props.className, className)
    }, textExtra));
  }
  return /*#__PURE__*/React.createElement(tagName, // $FlowFixMe[cannot-spread-inexact]
  _objectSpread({
    ref: innerRef || refCallback,
    className: clsx(textClasses, className)
  }, textExtra), children);
}
export default Text;